import { useEffect } from "react";
import { motion } from "framer-motion";
import retirementAssetsIllustration from "../../../static/illustration--retirement-assets.svg";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { useAnswer } from "../../../util/form";
import { useAppStore } from "../../../store/store";

export default function GoalsBasedStart({
  advanceScreen,
  previousScreen,
  validation,
  updateValidation,
  value,
  screen,
}) {
  const { user, form } = useAppStore();
  const { answer, setAnswer } = useAnswer(screen.id);

  // Initialize from saved answer
  useEffect(() => {
    if (answer) {
      // Restore validation if there's a saved answer
      updateValidation(answer === "goalsRetirementAge" || answer === "goalsAddAssets");
    } else {
      updateValidation(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleAnswerChange(value) {
    setAnswer(value);
    updateValidation(value === "goalsRetirementAge" || value === "goalsAddAssets");
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="w-full h-full px-6 py-16 text-center bg-white md:px-16 md:py-20">
        <div className="flex flex-col md:h-full">
          <div className="mb-10">
            <div className="max-w-xl mx-auto">
              <img
                className="block h-auto mx-auto w-28 md:w-36"
                src={retirementAssetsIllustration}
                alt=""
              />
              <h1 className="mt-6 mb-4 text-3xl md:mb-5 md:mt-8 md:text-4xl">
                Do you (or your spouse) have other retirement assets that you’d
                like to include in your review?
              </h1>
              <p>Examples: Previous 401(k)s, IRAs, brokerage accounts, etc.</p>
            </div>
            <div className="max-w-[37.125rem] mx-auto mt-4 md:mt-6">
              <RadioGroup.Root
                className="space-y-3"
                aria-label="My spouse and I do / do not have other retirement assets that we'd like to include in our review:"
                value={answer === "goalsRetirementAge" ? "no" : answer === "goalsAddAssets" ? "yes" : ""}
              >
                <div className="flex items-center">
                  <RadioGroup.Item
                    className="relative w-full rounded-lg border border-as-green-100 bg-transparent pb-4 pl-14 pr-4 pt-4 text-left before:absolute before:left-4 before:top-[1.1875rem] before:block before:h-4 before:w-4 before:rounded-full before:border before:border-as-green-100 before:bg-transparent before:content-[''] data-[state=checked]:bg-as-green-0 data-[state=checked]:before:bg-as-green-100"
                    value="no"
                    id="no"
                    onClick={() => handleAnswerChange("goalsRetirementAge")}
                  >
                    <RadioGroup.Indicator className="absolute left-[1.3125rem] top-6 h-1.5 w-1.5 rounded-full after:absolute after:inset-0 after:block after:h-1.5 after:w-1.5 after:rounded-full after:bg-white after:content-['']" />
                    <label
                      className="block text-sm font-bold leading-normal text-gray-800 cursor-pointer"
                      htmlFor="no"
                    >
                      No
                    </label>
                  </RadioGroup.Item>
                </div>
                <div className="flex items-center">
                  <RadioGroup.Item
                    className="relative w-full rounded-lg border border-as-green-100 bg-transparent pb-4 pl-14 pr-4 pt-4 text-left before:absolute before:left-4 before:top-[1.1875rem] before:block before:h-4 before:w-4 before:rounded-full before:border before:border-as-green-100 before:bg-transparent before:content-[''] data-[state=checked]:bg-as-green-0 data-[state=checked]:before:bg-as-green-100"
                    value="yes"
                    id="yes"
                    onClick={() => handleAnswerChange("goalsAddAssets")}
                  >
                    <RadioGroup.Indicator className="absolute left-[1.3125rem] top-6 h-1.5 w-1.5 rounded-full after:absolute after:inset-0 after:block after:h-1.5 after:w-1.5 after:rounded-full after:bg-white after:content-['']" />
                    <label
                      className="block text-sm font-bold leading-normal text-gray-800 cursor-pointer"
                      htmlFor="yes"
                    >
                      Yes
                    </label>
                  </RadioGroup.Item>
                </div>
              </RadioGroup.Root>
            </div>
          </div>
          <div className="flex justify-center gap-3 mt-10 md:mt-14 md:gap-5">
            <button
              type="button"
              className="btn btn--secondary"
              onMouseDown={(e) => {
                e.preventDefault();
                previousScreen(e);
              }}
            >
              Back
            </button>
            <button
              type="button"
              className="btn btn--primary"
              disabled={Boolean(validation) === false}
              onClick={advanceScreen}
            >
              Continue
            </button>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
